import lang from '@/lang'

export const CLIENT_INVITATION_STATUS = {
  INVITED: 'invited',
  REQUESTED: 'requested',
  PAUSED: 'paused',
  NOT_INVITED: 'not_invited',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  OFFLINE: 'offline',
}

export const CLIENT_CONNECTION_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  REQUESTED: 'requested',
  PAUSED: 'paused',
  OFFLINE: 'offline',
  REJECTED: 'rejected',
}

export const getInvitationStatusLabel = (status) => {
  return lang.clientList.invitationStatus[status]
}

export const getConnectionStatusLabel = (status) => {
  return lang.clientList.connectionStatus[status]
}
